import React from "react";

import { Form, Input, DatePicker, message } from "antd";
import moment from "moment";

import { Tabs, Popconfirm, Button } from "antd";
import TransactionsTable from "../TransactionsTable";

import SelectAzienda from "./SelectAzienda";
import SelectTipoCliente from "./SelectTipoCliente";
import SelectSiNo from "./SelectSiNo";



const { TabPane } = Tabs;


export default function ClienteDetail(props) {

  const [form] = Form.useForm();

  console.log(props.cliente)

  form.resetFields();

  const onFinish = (values) => {

    console.log('onFinish - Before validation');

    form.validateFields().then(() => {
      console.log(values)
      console.log('Success:', values);

      const currentState = props.cliente;
      currentState._source = values;

      props.clientAction(currentState)
    })

  };


  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }

  // function isCodiceNegozioEmpty(x) {
  //   if (x.length === 0) {
  //       return <Input />
  //   } else {
  //       return <Input disabled />
  //   }
  // }

  console.log(props.cliente._source.cardId)

  const handleSubmit = async () => {
    let builtinErrFields = [];
    let values;

    try {
      // Prova validazione AntD
      values = await form.validateFields();
    } catch (e) {
      // Prendi errori built-in + valori correnti
      builtinErrFields = e?.errorFields || [];
      values = form.getFieldsValue(true);
    }

    // --- Controlli manuali ---
    const manualErrFields = [];
    if (![0, 1].includes(values.consenso1)) {
      manualErrFields.push({ name: ['consenso1'], errors: ['Scegli il consenso Marketing'] });
    }
    if (![0, 1].includes(values.consenso2)) {
      manualErrFields.push({ name: ['consenso2'], errors: ['Scegli il consenso Profilazione'] });
    }

    // --- Unisci errori built-in + manuali (evita duplicati, concatena messaggi) ---
    const combineErrors = (a = [], b = []) => {
      const map = new Map();
      [...a, ...b].forEach(f => {
        const key = JSON.stringify(f.name);
        const prev = map.get(key);
        map.set(key, {
          name: f.name,
          errors: [...(prev?.errors || []), ...(f.errors || [])]
        });
      });
      return [...map.values()];
    };

    const allErrFields = combineErrors(builtinErrFields, manualErrFields);

    if (allErrFields.length) {
      form.setFields(allErrFields); // mostra TUTTI gli errori insieme
      return; // blocca submit
    }

    form.submit();
  };

  // parsing the dates to a moment object for the datepicker
  const client = props.cliente._source
  client.dataNascita = moment(client.dataNascita)

  client.dataScadenza = moment(client.dataScadenza)
  client.dataCaricamento = moment(client.dataCaricamento)

  client.spesaAnnoCorr = financial(client.spesaAnnoCorr)

  const init_date = moment("0001-01-01T00:00:00")

  // if the expiry date is 0001-01-01
  // then set it to dataCaricamento + 100 years

  if (client.dataScadenza.isSame(init_date)) {
    client.dataScadenza = client.dataCaricamento.add(100, 'years')
  }

  if (client.dataNascita.isSame(init_date)) {
    client.dataNascita = client.dataCaricamento.subtract(50, 'years')
  }


  // trimming all objects if they have empty spaces
  Object.keys(client).map(k => client[k] = typeof client[k] == 'string' ? client[k].trim() : client[k]);

  if ( client.codiceNegozio !== undefined && client.codiceNegozio.length === 0) {
    client.codiceNegozio = props.negozio
  }

  const isCardZ = client.cardId && client.cardId.startsWith('Z');

  const handleAziendaChange = (azienda) => {
    if (azienda) {
        form.setFieldsValue({
            codiceAzienda: azienda.codice,
            scontoFidelity: azienda.percentualeSconto,
            spesaAnnoPrec: 1
        });
    }
  };

  const handleTipoClienteChange = (tipoCliente) => {
    if (tipoCliente) {
        form.setFieldsValue({
            tipoClienteConvenzione: tipoCliente.codice
        });
    }
  };

  const handleConsMarketingChange = (scelta) => {
    if (scelta) {
        form.setFieldsValue({
            consenso1: scelta.value
        });
        if (![0, 1].includes(scelta.value)) {
          form.setFields([{ name: 'consenso1', errors: ['Scegli il consenso Marketing'] }]);
        } else {
          form.setFields([{ name: 'consenso1', errors: [] }]);
        }
    }
  };

  const handleConsProfilazioneChange = (scelta) => {
    if (scelta) {
        form.setFieldsValue({
            consenso2: scelta.value
        });
        if (![0, 1].includes(scelta.value)) {
          form.setFields([{ name: 'consenso2', errors: ['Scegli il consenso Profilazione'] }]);
        } else {
          form.setFields([{ name: 'consenso2', errors: [] }]);
        }
    }
  };

  if (props.cliente) {
    return (
      <div id="clienteDetail" key={props.cliente._source.cardId}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Anagrafica" key="1">
            <Form form={form} style={{ display: "flex" }} onFinish={onFinish} initialValues={client} >
              <div className="modal_inputs">
                <Form.Item
                  placeholder="Basic usage"
                  name="clienteId"
                  disabled
                  label="ID"
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  placeholder="Basic usage"
                  name="cardId"
                  label="Numero Card"
                >
                  <Input disabled/>
                </Form.Item>

                <Form.Item
                  placeholder="Basic usage"
                  name="ragso1"
                  label="Nome"
                  rules={[{ required: "true", message: "Il nome è necessario" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="ragso2"
                  rules={[{ required: "true", message: "Il cognome è necessario" }]}
                  label="Cognome">
                  <Input />
                </Form.Item>

                <Form.Item
                  name="indirizzo"
                  label="Indirizzo">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="comune"
                  label="Comune">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="cap"
                  label="cap">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="provincia"
                  label="provincia">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="stato"
                  label="stato">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder="Basic usage"
                  name="consenso1"
                  label="Cons. Mark. Diretto"
                  rules={[{ required: "true", message: "Scegli il consenso Marketing" }]}
                >
                  <SelectSiNo onValueChange={handleConsMarketingChange} />
                </Form.Item>

                <Form.Item
                  name="consenso2"
                  label="Cons. Profilazione"
                  rules={[{ required: true, message: "Scegli il consenso Profilazione" }]}>
                  <SelectSiNo onValueChange={handleConsProfilazioneChange} />
                </Form.Item>

              </div>

              <div className="modal_inputs">

                <Form.Item
                  placeholder=""
                  name="codfis"
                  label="Codice Fiscale">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="dataNascita"
                  label="Data Nascita"
                  >
                  
                  <DatePicker format={"DD/MM/YYYY"} />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="telefono"
                  label="Telefono">
                  <Input type="number" />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="email"
                  label="Email"
                  rules={[{ required: false, type: "email", message: "togliere email o rettificarla" }]}
                >

                  <Input type="email" />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="note"
                  label="note">
                  <Input />
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="dataCaricamento"
                  label="Data Caricamento">
                  { props.role === "admin" ?  <DatePicker format={"DD/MM/YYYY"}/>: <DatePicker format={"DD/MM/YYYY"} disabled/> }
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="dataScadenza"
                  label="Data Scadenza">
                  { props.role === "admin" ?  <DatePicker format={"DD/MM/YYYY"}/>: <DatePicker format={"DD/MM/YYYY"} disabled/> }
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="codiceNegozio"
                  label="Codice Negozio">
                  { props.role === "admin" ? <Input /> : <Input disabled /> }
                </Form.Item>

              </div>

              <div className="modal_inputs">


                <Form.Item
                  placeholder=""
                  name="sogliaPremi"
                  label="Soglia Premi">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>

                <Form.Item
                  placeholder=""
                  name="scontoFidelity"
                  label="Sconto Fidelity">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>


                <Form.Item
                  placeholder=""
                  name="spesaAnnoPrec"
                  label="Spesa Anno Prec">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>


                <Form.Item
                  placeholder=""
                  name="spesaAnnoCorr"
                  label="Spesa Anno Corrente">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>


                <Form.Item
                  placeholder=""
                  name="storicoPunti"
                  label="Storico Punti">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>


                <Form.Item
                  placeholder=""
                  name="storicoSpesa"
                  label="Storico Spesa">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>


                <Form.Item
                  placeholder=""
                  name="fidelityOfferte"
                  label="Fidelity Offerte">
                  { props.role === "admin" ? <Input type="number" /> : <Input disabled /> }
                </Form.Item>

                {isCardZ && (
                  <Form.Item
                      name="codiceAzienda"
                      label="Convenzione"
                      rules={[{ required: true, message: "La convenzione è obbligatoria" }]}
                  >
                      <SelectAzienda onAziendaChange={handleAziendaChange} />
                  </Form.Item>
                )}

                {isCardZ && (
                  <Form.Item
                      name="tipoClienteConvenzione"
                      label="Tipo Cliente"
                      rules={[{ required: true, message: "Il tipo cliente è obbligatorio" }]}
                  >
                      <SelectTipoCliente onTipoClienteChange={handleTipoClienteChange} />
                  </Form.Item>
                )}

                <Form.Item>
                  <Popconfirm
                    key="2"
                    placement="topRight"
                    title="Sicuro di voler aggiornare questo cliente ?"
                    okText="Si"
                    onConfirm={handleSubmit}
                    cancelText="No"
                  >
                    <Button type="primary" htmlType="submit">
                      Aggiorno
                    </Button>
                  </Popconfirm>
                </Form.Item>
              </div>
            </Form>
          </TabPane>

          <TabPane tab="Transazioni" key="2">
            <TransactionsTable cardId={props.cliente._source.cardId} />
          </TabPane>
        </Tabs>
      </div>
    )
  } else {
    message.error("Questa carta non esiste")
    return <h1>hi there</h1>
  }
}